var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.serverNotResponding)?_c('div',[_vm._t("not-responding",[(_vm.serverNotResponding)?_c('b',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.d_message))]):_vm._e(),_c('div',[_vm._t("default")],2)])],2):_c('div',[_vm._t("responding")],2)}
var staticRenderFns = []

export { render, staticRenderFns }